// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { ContentModule } from "../../common/content_module/ContentModule";
import { reaction } from "mobx";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { Api } from "../../../api";
import { StageVanSolutionModule } from "../stage_van_solution_module/StageVanSolutionModule";
import { StageVanPartnerModule } from "../stage_van_partner_module/StageVanPartnerModule";
import RoundedButton from "#/components/rounded_button/RoundedButton";
import Comparison from "../filter_module/comparison/Comparison";
import ProductComparison from "../filter_module/product_comparison/ProductComparison";
import { StageLoading } from "../stage_loading/StageLoading";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    StageVanSolutionModule,
    StageVanPartnerModule,
    RoundedButton,
    Comparison,
    ProductComparison,
    StageLoading,
  },
})
export class ProductStageModule extends ModuleBase {
  stageHeight = 0;
  openComparison = false;
  openProductComparison = false;

  getBackgroundColorFromInstance(instance: object): string {
    return "black";
  }

  created() {
    this.$store.conversionWorldProduct.getProduct(
      Number.parseInt(this.$store.page.page!.route_parameter["productId"]),
      this.$store.page.page!.id
    );
  }

  get product() {
    return this.$store.conversionWorldProduct.current;
  }

  get vanSolutionInstance() {
    return {
      id: this.instance["id"],
      design: this.instance["design"],
      translation: this.instance["van-solution"],
      "comparision-layer": this.instance["comparision-layer"],
      comparision: this.instance["comparision"],
      optional: this.getOptional(this.instance),
      common_options: this.instance["common_options"],
    };
  }

  get vanPartnerInstance() {
    return {
      id: this.instance["id"],
      design: this.instance["design"],
      translation: this.instance["van-partner"],
      "comparision-layer": this.instance["comparision-layer"],
      comparision: this.instance["comparision"],
      optional: this.getOptional(this.instance),
      common_options: this.instance["common_options"],
    };
  }

  public getOptional(instance) {
    let images: object[] = [];
    if (
      instance["product-image-1"] &&
      !this.isImageDeleted(instance["product-image-1"])
    ) {
      images.push({
        image: instance["product-image-1"],
        title: "",
      });
    }

    if (
      instance["product-image-2"] &&
      !this.isImageDeleted(instance["product-image-2"])
    ) {
      images.push({
        image: instance["product-image-2"],
        title: "",
      });
    }

    return {
      images: images,
      mainbranche: instance["main-branche"],
      productname: instance["product-name"],
    };
  }

  private isImageDeleted(imageData) {
    return (
      Object.keys(imageData).length === 0 ||
      Object.keys(imageData).every((k) => {
        return imageData[k] === "DELETE_IMAGE";
      })
    );
  }

  public handleComparisonOpen(value) {
    this.openProductComparison = value;
  }
}
